import { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { X } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

function todayKey(userId) {
  const d = new Date();
  const ymd = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return `dp_welcome_seen_${userId}_${ymd}`;
}

export default function WelcomeVideoModal() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!user || user === false) return;
    const key = todayKey(user.id);
    try {
      if (!localStorage.getItem(key)) {
        setOpen(true);
      }
    } catch {
      // localStorage blocked — just don't show
    }
  }, [user]);

  const handleClose = () => {
    if (user && user.id) {
      try {
        localStorage.setItem(todayKey(user.id), "1");
      } catch {
        /* ignore */
      }
    }
    try {
      videoRef.current?.pause();
    } catch {
      /* ignore */
    }
    setOpen(false);
  };

  if (!user || user === false) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) handleClose();
      }}
    >
      <DialogContent
        className="sm:max-w-2xl p-0 overflow-hidden border-0 bg-black [&>button]:hidden"
        data-testid="welcome-video-modal"
      >
        <div className="relative">
          <video
            ref={videoRef}
            src="/welcome.mp4"
            autoPlay
            playsInline
            controls
            className="w-full aspect-video bg-black"
          />
          <button
            type="button"
            onClick={handleClose}
            data-testid="welcome-video-close-btn"
            className="absolute top-3 right-3 h-9 w-9 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center backdrop-blur transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="dp-gradient-bg p-4 flex items-center justify-between gap-3 text-white">
          <div>
            <div className="font-display font-bold text-lg leading-tight">
              Welcome back!
            </div>
            <div className="text-xs opacity-90 mt-0.5">
              A quick message from Design Plus — have a great shift.
            </div>
          </div>
          <Button
            variant="secondary"
            className="bg-white text-foreground hover:bg-white/90 shrink-0"
            onClick={handleClose}
            data-testid="welcome-video-continue-btn"
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
